/* global $ */

(function (angular) {
    'use strict';

    angular.module('app')
        .directive('mobileMoveAboveContent', mobileMoveAboveContent);

    mobileMoveAboveContent.$inject = [
        '$timeout'
    ];

    /**
     * Detaches this element from the DOM, and moves it to a container above the content
     */
    function mobileMoveAboveContent(
        $timeout
    ) {

        function mobileMoveAboveContentLink($scope, el) {
            el = $(el);
            var originalContainer = el.parent(),
                timer = null;

            function moveAbove() {
                el.detach().appendTo('#mobile-moved-items');
            }

            function moveBelow() {
                el.detach().appendTo(originalContainer);
            }

            function shouldMove() {
                var windowWidth = $(window).width(),
                    requiredPosition = (windowWidth < 991 ? 'above' : 'below'),
                    containerId = el.parent().attr('id');

                if (requiredPosition === 'above' && containerId !== 'mobile-moved-items') {
                    moveAbove();
                }
                if (requiredPosition === 'below' && containerId === 'mobile-moved-items') {
                    moveBelow();
                }
            }

            $(window).resize(function () {
                $timeout.cancel(timer);
                $timeout(shouldMove, 200);
            });
            shouldMove();
        }

        return {
            restrict: 'A',
            link: mobileMoveAboveContentLink
        };
    }

}(angular));
